export default __webpack_public_path__ + "media/images/home/slide_hot_spring_2022_lg-9329cc1d6f03e1f5f867b8bd1f28c8ab.jpg";